import StartupsFundraisesInstance from 'modules/startupsFundraises/repository';

export const getStartupFundraises = (startup, options) => StartupsFundraisesInstance.getStartupFundraises(startup, options);

export const deleteStartupFundraise = (startup, fundraise) => StartupsFundraisesInstance.deleteStartupFundraise(startup, fundraise);
